export const CONTENT_TYPE_FIELD = 'content_type';
export const PORTAL_ID_FIELD = 'portal_id';
export const CONTENT_ID_FIELD = 'content_id';
export const NAME_FIELD = 'name';
export const CREATED_AT_FIELD = 'created_at';
export const UPDATED_AT_FIELD = 'updated_at';
export const LAST_USED_AT_FIELD = 'last_used_at';
export const USER_ID_FIELD = 'user_id';
export const TEAM_ID_FIELD = 'team_id';
export const SHORTCUT_FIELD = 'shortcut';
export const FOLDER_ID_FIELD = 'folder_id';
export const LAST_VIEWED_AT_FIELD = 'lastViewedAt';
export const TIMES_VIEWED_FIELD = 'timesViewed';
export const TOTAL_VIEWS = 'total_views';